<div class="page">
  <h3>
    Запросы на обратную связь
  </h3>
  <ng2-smart-table [settings]="settings" [source]="feedbackList"></ng2-smart-table>

</div>
